import React from 'react';

interface Props {
  color?: string;
  secondaryColor?: string;
  darkColor?: string;
}

const AssistantIntro: React.FC<React.PropsWithChildren<Props>> = ({
  color = '#FF8000',
  secondaryColor = '#BCACCC',
  darkColor = '#3C2E4B',
  ...otherProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="372"
      height="372"
      fill="none"
      viewBox="0 0 372 372"
      {...otherProps}
    >
      <g clipPath="url(#clip0)">
        <path fill="#fff" d="M0 0H372V372H0z"></path>
        <mask
          id="mask0"
          width="372"
          height="372"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#C4C4C4" d="M0 0H372V372H0z"></path>
        </mask>
        <g mask="url(#mask0)">
          <path
            fill="#FFF2E5"
            d="M267.64 270.33c34.596 4.241 80.473 4.018 105.041 21.653 24.819 17.858 28.078 53.129 14.039 81.479-13.788 28.351-44.874 49.335-62.172 78.355-17.298 29.243-20.557 66.076-41.114 78.354-20.557 12.054-58.412-.893-88.746-12.278-30.083-11.385-53.147-21.207-84.735-27.681-31.587-6.25-71.949-9.152-98.522-26.787-26.574-17.636-39.109-50.227-32.841-79.694 6.016-29.466 30.835-55.585 50.39-83.712 19.804-28.127 34.344-58.263 59.915-66.969 25.571-8.929 61.922 3.572 91.754 14.064 29.582 10.491 52.646 18.974 86.991 23.216z"
          ></path>
          <path
            fill={secondaryColor}
            d="M80.887 207.611c8.5 9.7 11.9 23.7 10.2 35.6-1.7 11.9-8.5 21.8-7.3 32.4 1.2 10.5 10.3 21.8 10.7 31.5.4 9.7-7.8 17.8-17.6 18.2-9.7.4-20.9-6.9-33.2-4.9-12.4 2-25.9 13.3-32.3 11-6.4-2.3-5.8-18.3-5.6-30 .3-11.6.1-19.1-1.7-27.6-1.9-8.5-5.5-18.1-3.5-25.8 2-7.8 9.7-13.7 18-23.6 8.3-9.9 17.2-23.8 28.6-28 11.4-4.2 25.1 1.4 33.7 11.2z"
          ></path>
          <path
            fill={darkColor}
            stroke={darkColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M47 228.989a.5.5 0 00-1-.005l-4.5 142.5a.501.501 0 00.5.516h7.5a.5.5 0 00.5-.511l-3-142.5z"
          ></path>
          <path
            fill={darkColor}
            stroke={darkColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M74.792 237.638a.5.5 0 00-.564-.824L45.74 254.2a.5.5 0 00-.24.427V259a.5.5 0 00.804.397l28.49-21.759zM13.646 250.353a.5.5 0 01.667-.743l31.934 25.627a.5.5 0 01.187.39V282a.5.5 0 01-.854.353l-31.934-32zM72.413 271.282a.5.5 0 00-.79-.61l-24.876 28.627a.499.499 0 00-.123.328v7.873a.5.5 0 00.914.282l24.875-36.5z"
          ></path>
          <path
            fill={secondaryColor}
            d="M281.614 207.611c-8.5 9.7-11.9 23.7-10.2 35.6 1.7 11.9 8.5 21.8 7.3 32.4-1.2 10.5-10.3 21.8-10.7 31.5-.4 9.7 7.8 17.8 17.6 18.2 9.7.4 20.9-6.9 33.2-4.9 12.4 2 25.9 13.3 32.3 11 6.4-2.3 5.8-18.3 5.6-30-.3-11.6-.1-19.1 1.7-27.6 1.9-8.5 5.5-18.1 3.5-25.8-2-7.8-9.7-13.7-18-23.6-8.3-9.9-17.2-23.8-28.6-28-11.4-4.2-25.1 1.4-33.7 11.2z"
          ></path>
          <path
            fill={darkColor}
            stroke={darkColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M315.501 228.989a.5.5 0 011-.005l4.5 142.5a.503.503 0 01-.5.516h-7.5a.5.5 0 01-.5-.511l3-142.5z"
          ></path>
          <path
            fill={darkColor}
            stroke={darkColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M287.709 237.638a.5.5 0 01.564-.824l28.489 17.386a.5.5 0 01.239.427V259a.5.5 0 01-.803.397l-28.489-21.759zM348.855 250.353a.5.5 0 00-.667-.743l-31.934 25.627a.5.5 0 00-.187.39V282a.5.5 0 00.854.353l31.934-32zM290.088 271.282a.5.5 0 01.79-.61l24.876 28.627a.499.499 0 01.122.328v7.873a.501.501 0 01-.913.282l-24.875-36.5z"
          ></path>
          <circle
            cx="102"
            cy="106"
            r="2"
            stroke={color}
            strokeWidth="2"
          ></circle>
          <circle
            cx="69.5"
            cy="134.5"
            r="3.5"
            stroke="#6F558A"
            strokeWidth="2"
          ></circle>
          <circle cx="61" cy="84" r="5" stroke={color} strokeWidth="2"></circle>
          <circle
            cx="161"
            cy="254"
            r="5"
            stroke={color}
            strokeWidth="2"
          ></circle>
          <circle
            cx="199"
            cy="242"
            r="3"
            stroke="#F93"
            strokeWidth="2"
          ></circle>
          <circle
            cx="258"
            cy="221"
            r="2"
            stroke="#6F558A"
            strokeWidth="2"
          ></circle>
          <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
            d="M1.5 370.5L370.5 370.5"
          ></path>
          <path
            stroke="#DBDDE1"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M186 230.75V136c0-3 2-5 5-5h15c2 0 4-1.5 4-4V93"
          ></path>
          <path fill="#fff" d="M208 99H212V112H208z"></path>
          <path
            stroke="#DBDDE1"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M210 101.5L210 109.5"
          ></path>
          <circle cx="210" cy="99" r="0.5" fill="#DBDDE1"></circle>
          <circle cx="210" cy="112" r="0.5" fill="#DBDDE1"></circle>
          <rect
            width="53"
            height="53"
            x="183.5"
            y="34.5"
            fill={color}
            stroke={color}
            rx="5.5"
          ></rect>
          <rect
            width="53"
            height="53"
            x="183.5"
            y="30.5"
            fill="#fff"
            stroke={color}
            rx="5.5"
          ></rect>
          <path
            fill={darkColor}
            d="M227.811 57.182c-.037-.822-.701-1.494-1.512-1.569l-6.564-.56-4.868-5.007A3.551 3.551 0 00212.36 49h-8.002c-1.143 0-2.213.56-2.877 1.532l-3.134 4.483-3.798.187c-.848.038-1.549.785-1.549 1.644v3.96c0 .935.738 1.682 1.659 1.682h3.245c.148 1.943 1.77 3.512 3.725 3.512 1.954 0 3.577-1.532 3.724-3.512h10.325c.148 1.943 1.77 3.512 3.725 3.512 1.991 0 3.577-1.532 3.724-3.512h3.245a1.63 1.63 0 001.623-1.756l-.184-3.55zm-26.182 6.8c-.996 0-1.807-.822-1.807-1.83 0-1.01.811-1.831 1.807-1.831.996 0 1.807.822 1.807 1.83 0 1.01-.811 1.831-1.807 1.831zm5.31-9.153h-5.273l1.954-2.803c.185-.224.443-.373.738-.373h2.581v3.176zm2.618 0v-3.176h2.803c.258 0 .479.112.627.261l2.839 2.915h-6.269zm9.846 9.153c-.996 0-1.807-.822-1.807-1.83 0-1.01.811-1.831 1.807-1.831.996 0 1.807.822 1.807 1.83 0 1.01-.811 1.831-1.807 1.831z"
          ></path>
          <path
            stroke="#DBDDE1"
            strokeLinecap="round"
            d="M202 131h77.5c3.5 0 4-2 4-4.5V116"
          ></path>
          <path
            fill="#fff"
            d="M222.5 133H226.5V146H222.5z"
            transform="rotate(-90 222.5 133)"
          ></path>
          <path
            stroke="#DBDDE1"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M225 131L228 131"
          ></path>
          <path
            stroke="#DBDDE1"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M230 131L233 131"
          ></path>
          <circle
            cx="222.5"
            cy="131"
            r="0.5"
            fill="#DBDDE1"
            transform="rotate(-90 222.5 131)"
          ></circle>
          <circle
            cx="235.5"
            cy="131"
            r="0.5"
            fill="#DBDDE1"
            transform="rotate(-90 235.5 131)"
          ></circle>
          <rect
            width="41.828"
            height="41.828"
            x="263.5"
            y="68.672"
            fill={color}
            stroke={color}
            rx="5.5"
          ></rect>
          <rect
            width="41.828"
            height="41.828"
            x="263.5"
            y="65.5"
            fill="#fff"
            stroke={color}
            rx="5.5"
          ></rect>
          <path
            fill={darkColor}
            d="M293.318 81.878l-2.278-1.53v-3.43a.64.64 0 00-.64-.64h-2.56a.64.64 0 00-.64.64v.858l-2.848-1.92a.642.642 0 00-.704 0l-8.96 6.01a.637.637 0 00-.288.537V95.6a.64.64 0 00.64.64h3.84v-6.4a.64.64 0 01.64-.64h3.2a.638.638 0 01.64.64v6.4h9.6a.638.638 0 00.64-.64V82.416a.644.644 0 00-.282-.538z"
          ></path>
          <path
            stroke="#DBDDE1"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M242 131c3 0 5 2.324 5 4.971V146"
          ></path>
          <rect
            width="36.241"
            height="36.241"
            x="228.5"
            y="154.629"
            fill={color}
            stroke={color}
            rx="5.5"
          ></rect>
          <rect
            width="36.241"
            height="36.241"
            x="228.5"
            y="151.5"
            fill="#fff"
            stroke={color}
            rx="5.5"
          ></rect>
          <path
            fill={darkColor}
            d="M252.28 163.27a.59.59 0 00-.115-.148.783.783 0 00-.447-.135h-4.204v-1.085a.537.537 0 00-.543-.542.546.546 0 00-.501.335.546.546 0 00-.041.207v1.085h-4.205a.778.778 0 00-.446.135.617.617 0 00-.116.148l-2.822 4.882v.274a2.97 2.97 0 00.98 2.207 2.974 2.974 0 002.294.754 3.057 3.057 0 002.688-3.096v-.139l-2.04-3.538h3.667v11.381h-3.523a.269.269 0 00-.269.269v1.627a.263.263 0 00.269.269h8.131a.266.266 0 00.191-.077.278.278 0 00.059-.088.282.282 0 00.019-.104v-1.627a.27.27 0 00-.269-.269h-3.523v-11.381h3.667l-2.04 3.538v.139a3.057 3.057 0 002.688 3.096 2.967 2.967 0 002.294-.754 2.968 2.968 0 00.979-2.207v-.274l-2.822-4.882zm-8.726 4.882h-3.461l1.728-2.99 1.733 2.99zm6.835 0l1.733-2.99 1.728 2.99h-3.461z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H372V372H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AssistantIntro;
